'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _Layouts;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _layouts = require('../utils/layouts');

var _widgetsUtils = require('widgets-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Layouts = (_Layouts = {}, _Layouts[_layouts.WF_HORIZONTAL_XL] = _layouts.Horizontal_XL, _Layouts[_layouts.WF_HORIZONTAL_L] = _layouts.Horizontal_L, _Layouts[_layouts.WF_HORIZONTAL_M] = _layouts.Horizontal_M, _Layouts[_layouts.WF_HORIZONTAL_S] = _layouts.Horizontal_S, _Layouts[_layouts.WF_HORIZONTAL_XS] = _layouts.Horizontal_XS, _Layouts[_layouts.WF_HORIZONTAL_A] = _layouts.Horizontal_A, _Layouts);

var DoctifyWfHorizontal = function (_WfAbstractComponent) {
    (0, _inherits3.default)(DoctifyWfHorizontal, _WfAbstractComponent);

    function DoctifyWfHorizontal() {
        (0, _classCallCheck3.default)(this, DoctifyWfHorizontal);
        return (0, _possibleConstructorReturn3.default)(this, _WfAbstractComponent.apply(this, arguments));
    }

    DoctifyWfHorizontal.prototype.render = function render() {
        var starsSize = this.state.width < 400 ? 'STARS_SIZE_M' : 'STARS_SIZE_L';
        var logoSize = this.state.width < 400 ? _widgetsUtils.DoctifyLogo.LOGO_SIZE_EXTRA_SMALL : _widgetsUtils.DoctifyLogo.LOGO_SIZE_SMALL;

        var Layout = Layouts[this.props.layoutType] || _layouts.Horizontal_XL;

        return _react2.default.createElement(Layout, (0, _extends3.default)({}, this.props, { starsSize: starsSize, logoSize: logoSize }));
    };

    return DoctifyWfHorizontal;
}(_widgetsUtils.WfAbstractComponent);

DoctifyWfHorizontal.displayName = 'DoctifyWfHorizontal';

DoctifyWfHorizontal.defaultProps = {
    layoutType: _layouts.WF_HORIZONTAL_XL,
    wrapperFrame: true
};

exports.default = DoctifyWfHorizontal;